<template>
	<v-app>
		<main-nav />
		<side-nav> </side-nav>
		<router-view class="pt-5" />
	</v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainNav from './components/ui/MainNav.vue';
import SideNav from './components/ui/SideNav.vue';

export default {
	components: { SideNav, MainNav },
	name: 'App',

	data: () => ({
		collapseOnScroll: true
	}),
	methods: {
		...mapActions(['LOGOUT'])
	},
	computed: {
		...mapGetters(['getSession', 'getLogin'])
	}
};
</script>

<style>
body::-webkit-scrollbar {
	width: 0.8em;
}

body::-webkit-scrollbar-track {
	-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

body::-webkit-scrollbar-thumb {
	background: rgb(207, 216, 218);
	background: linear-gradient(90deg, rgba(207, 216, 218, 1) 0%, rgba(160, 166, 167, 1) 50%, rgba(207, 216, 218, 1) 100%);

	border-radius: 20px;
}
</style>
